import { render } from "./post_status_modal.vue?vue&type=template&id=1034feee"
import script from "./post_status_modal.js?vue&type=script&lang=js"
export * from "./post_status_modal.js?vue&type=script&lang=js"

import "./post_status_modal.vue?vue&type=style&index=0&id=1034feee&lang=scss"

import exportComponent from "/home/jojo/Documents/aspho-fe-pleromer/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__